export const ACM_TAG = 'acm';
export const ARTICLES_TAG = 'articles';
export const BLOCKS_TAG = 'blocks';
export const CATEGORY_TAG = 'category';
export const COMMENT_TAG = 'comment';
export const DOCIMPORT_TAG = 'docimport';
export const DOCUMENT_TAG = 'document';
export const INVITATION_RTK_TAG = 'invitation';
export const KB_TAG = 'kb';
export const NOTIFICATION_TAG = 'notification';
export const PLAN_TAG = 'plan';
export const REACTION_TAG = 'reaction';
export const ROLETAG = 'role';
export const SEARCH_TAG = 'search';
export const TEAMTAG = 'team';
export const THEMES_TAG = 'themes';
export const USER_RTK_TAG = 'user';
export const VIDEO_TAG = 'video';

export const ACCEPTANCE_RTK_TAGS = {
  TAGS: 'acceptance',
  VERSION_STATUS_TAG: 'acceptance_version_status',
};
export const ACTIVITY_RTK_TAGS = {
  TAGS: 'activity',
};
export const CURRENT_USER_TAGS = {
  TOKENS: 'TOKENS',
  SCOPED: 'SCOPED',
  USER: 'USER',
};
export const FOLDER_TAGS = {
  TAGS: 'FOLDER',
  HASHID: 'FOLDERHASHID',
};
export const LANE_RTK_TAGS = {
  TAGS: 'lane',
};
export const MARKET_RTK_TAGS = {
  TAGS: 'market',
};
export const MEDIAACCESS_RTK_TAGS = {
  TAGS: 'mediaaccess',
};
export const POLICY_RTK_TAGS = {
  TAGS: 'POLICY',
  HASHID: 'POLICYHASHID',
  VERSIONS: 'POLICYVERSION',
};
export const PROCEDURE_RTK_TAGS = {
  TAGS: 'PROCEDURE',
  HASHID: 'PROCEDUREHASHID',
  VERSIONS: 'PROCEDUREVERSION',
};
export const PROCESS_RTK_TAGS = {
  TAGS: 'PROCESS',
  HASHID: 'PROCESSHASHID',
};
export const QUIZ_TAGS = {
  TAG: 'QUIZ',
  VERSION: 'QUIZVERSION',
  ATTEMPT: 'QUIZATTEMPT',
};
export const RECYCLED_TAGS = {
  TAG: 'recycle',
};
export const REFERRALS_TAGS = {
  CODES: 'referral_codes',
  REFERRALS: 'referral_referrals',
};
export const SCIM_TAGS = {
  TEAM: 'scimteams',
};
export const SETTINGSTAGS = {
  TAGS: 'settings',
  TIMEZONES: 'settings-timezones',
  LANGUAGES: 'settings-lanuage',
};
export const SIGNOFF_TAGS = {
  TAGS: 'signoff',
};
export const TAGS_RTK_TAGS = {
  TAGS: 'Tags',
};
export const TASKS_RTK_TAGS = {
  INSTANCE: 'taskinstance',
  SLIMINSTANCE: 'slimtaskinstance',
  TEMPLATE: 'tasktemplate',
};
export const TEMPLATE_RTK_TAGS = {
  TAGS: 'template',
};
